import { TSpotlightData, TSubmitSpotlightData } from './types';

const allowedUserStatsTypes = ['FAVORITE_GAME', 'OCCUPATION', 'LOCATION'];
export const dehydrateFormData = (data: TSubmitSpotlightData): TSpotlightData => {
	const deHydratedData: TSpotlightData = {
		data: {
			durationInSec: data.durationInSec,
			thumbnailUrl: data.thumbnailUrl,
			videoUrl: data.videoUrl,
			shareUrl: data.shareUrl
		},
		liveSince: data.liveSince,
		liveTill: data.liveTill,
		archiveTime: data.archiveTime,
		userStats: data.userStats.map((stat) => {
			return {
				type: stat.statsType,
				value: {
					en: stat.statsValueEn,
					hi: stat.statsValueHi,
					mr: stat.statsValueMr
				}
			};
		}),
		userData: {
			zupeeUserId: data.zupeeUserId,
			displayName: {
				en: data.displayNameEn,
				hi: data.displayNameHi,
				mr: data.displayNameMr
			}
		},
		viewCount: {
			value: data.viewCount
		},
		createdAt: data.createdAt,
		updatedAt: data.updatedAt,
		tagInfo: {
			type: data.tagInfoType,
			title: {
				en: data.tagInfoTitleEn as string,
				hi: data.tagInfoTitleHi as string,
				mr: data.tagInfoTitleMr as string
			},
			description: {
				en: data.tagInfoDescEn as string,
				hi: data.tagInfoDescHi as string,
				mr: data.tagInfoDescMr as string
			}
		}
	};

	return deHydratedData;
};

export const updateFormData = (data: TSubmitSpotlightData): Partial<TSpotlightData> => {
	const updateData: Partial<TSpotlightData> = {
		_id: data.id,
		data: {
			durationInSec: data.durationInSec,
			thumbnailUrl: data.thumbnailUrl,
			videoUrl: data.videoUrl,
			shareUrl: data.shareUrl
		},
		liveSince: data.liveSince,
		liveTill: data.liveTill,
		userStats: data.userStats.map((stat) => {
			return {
				type: stat.statsType,
				value: {
					en: stat.statsValueEn,
					hi: stat.statsValueHi,
					mr: stat.statsValueMr
				}
			};
		}),
		userData: {
			zupeeUserId: data.zupeeUserId,
			displayName: {
				en: data.displayNameEn,
				hi: data.displayNameHi,
				mr: data.displayNameMr
			}
		},
		tagInfo: {
			type: data.tagInfoType,
			title: {
				en: data.tagInfoTitleEn as string,
				hi: data.tagInfoTitleHi as string,
				mr: data.tagInfoTitleMr as string
			},
			description: {
				en: data.tagInfoDescEn as string,
				hi: data.tagInfoDescHi as string,
				mr: data.tagInfoDescMr as string
			}
		}
	};

	return updateData;
};

export const hydrateFormData = (data: TSpotlightData) => {
	const filteredStats = data.userStats.filter((stat) => allowedUserStatsTypes.includes(stat.type));
	const spotlightData: TSubmitSpotlightData = {
		zupeeUserId: data.userData.zupeeUserId,
		displayNameEn: data.userData.displayName.en,
		displayNameHi: data.userData.displayName.hi,
		displayNameMr: data.userData.displayName.mr,
		userStats: filteredStats.map((stat) => {
			return {
				statsType: stat.type,
				statsValueEn: stat.value.en,
				statsValueHi: stat.value.hi,
				statsValueMr: stat.value.mr
			};
		}),
		liveSince: data.liveSince,
		liveTill: data.liveTill,
		archiveTime: data.archiveTime,
		createdAt: data.createdAt,
		updatedAt: data.updatedAt,
		viewCount: data.viewCount.value,
		durationInSec: data.data.durationInSec,
		thumbnailUrl: data.data.thumbnailUrl,
		videoUrl: data.data.videoUrl,
		shareUrl: data.data.shareUrl,
		tagInfoType: data?.tagInfo?.type,
		tagInfoTitleEn: data?.tagInfo?.title?.en,
		tagInfoTitleHi: data?.tagInfo?.title?.hi,
		tagInfoTitleMr: data?.tagInfo?.title?.mr,
		tagInfoDescEn: data?.tagInfo?.description?.en,
		tagInfoDescHi: data?.tagInfo?.description?.hi,
		tagInfoDescMr: data?.tagInfo?.description?.mr,
		id: data._id
	};

	return spotlightData;
};
